export const beveragePlaceholders = {
  Coffee: "e.g., iced, w/ half and half, extra sweet",
  Tea: "e.g., Earl Grey, milk and sugar, Gold Peak Unsweetened",
  Juices: "e.g. orange, pineapple, Simply lemonade",
  Milk: "e.g. 2%, skim, almond milk",
  Water: "e.g. SmartWater , Topo Chico,  Sparkling, without ice",
  Soda: "e.g., Coke, Diet Coke, Coke Zero, Sprite, Seagram’s Ginger Ale",
  "Energy Drink": "e.g., Monster Energy, Powerade",
  Beer: "e.g. Bud Light, IPA, Craft",
  Wine: "e.g. Chardonnay, Merlot",
  Spirits:
    "e.g. Spicy Margarita, Dirty Martini w/ blue cheese-stuffed olives, Maotai Baijiu, on the rocks",
};
